/* Catching up on one of Hiring's own messages, on that message's own page
 * (owner, 30 Oct 2026: no separate Templates screen). Each is two deliberate
 * steps: "find" only shows a person who would get it; only the second press
 * sends.
 *   MissedWhatsApp  people who got the email but whose WhatsApp never went
 *                   (fee due, fee paid)
 *   TellOut         people who are out and were never told (not moving
 *                   forward) — HIR-CN2
 */
import React, { useState } from 'react';
import api from '../../services/api';
import { Button, Input } from '../../ds';
import { Section, Note } from '../../components/page';

const list = { margin: 0, paddingLeft: 18, display: 'grid', gap: 4, fontSize: 14, color: 'var(--text-1)' };
const small = { fontSize: 13, color: 'var(--text-2)' };
const errOf = (e, fallback) => e?.response?.data?.message || fallback;

export function MissedWhatsApp() {
  const [r, setR] = useState(null); // null | {running} | plan | results | {error}
  const run = (confirm) => {
    setR({ running: true });
    api.post('/school-settings/resend-missed-whatsapp', confirm ? { confirm: true } : {})
      .then((x) => setR(x.data.data))
      .catch((e) => setR({ error: errOf(e, confirm ? 'Could not send. Try again.' : 'Could not check for missed WhatsApps.') }));
  };
  const what = (k) => (k === 'paid' ? 'the application-complete message' : 'the fee-due message with the payment button');
  return (
    <Section title="Missed WhatsApps" subtitle="applicants who got the email but whose WhatsApp never went"
      action={<Button variant="secondary" onClick={() => run(false)} loading={r?.running} disabled={r?.running}>Find missed</Button>}>
      <div style={{ display: 'grid', gap: 10 }}>
        <div style={small}>Finding them sends nothing: you see the list first, and each person gets the message that matches where they stand today.</div>
        {r?.error && <Note tone="danger">{r.error}</Note>}
        {r?.dryRun && (r.count === 0
          ? <Note tone="success">Nobody is missing a WhatsApp.</Note>
          : (
            <>
              <ul style={list}>{r.plan.map((p) => <li key={p.applicationId}><b>{p.candidateName}</b> · {p.applicationId} · will get {what(p.kind)}</li>)}</ul>
              <div><Button onClick={() => run(true)}>Send these {r.count} WhatsApp{r.count > 1 ? 's' : ''} now</Button></div>
            </>
          ))}
        {r && r.dryRun === false && (
          <ul style={list}>{r.results.map((x) => <li key={x.applicationId}>{x.sent ? 'Sent' : 'Not sent'}: {x.candidateName} ({x.applicationId}){x.error ? ` · ${x.error}` : ''}</li>)}</ul>
        )}
      </div>
    </Section>
  );
}

export function TellOut() {
  const [since, setSince] = useState(() => new Date(Date.now() - 14 * 864e5).toISOString().slice(0, 10));
  const [r, setR] = useState(null);
  const run = (confirm) => {
    setR({ running: true });
    api.post('/school-settings/tell-out-candidates', confirm ? { since, confirm: true } : { since })
      .then((x) => setR(x.data.data))
      .catch((e) => setR({ error: errOf(e, confirm ? 'Could not send. Try again.' : 'Could not check who is out.') }));
  };
  return (
    <Section title="Out and not told yet" subtitle="everyone who applied should hear from us, including when the answer is no"
      action={<Button variant="secondary" onClick={() => run(false)} loading={r?.running} disabled={r?.running}>Find who is out</Button>}>
      <div style={{ display: 'grid', gap: 10 }}>
        <div style={small}>Finding them sends nothing: you see the list first. Anyone out for less than a day is left alone, and anyone a person has not given up on is held for you to look at.</div>
        <div style={{ maxWidth: 260 }}>
          <Input id="tell-out-since" type="date" label="Only people who applied on or after" value={since} onChange={(e) => setSince(e.target.value)} />
        </div>
        {r?.error && <Note tone="danger">{r.error}</Note>}
        {r?.dryRun && (
          <>
            {r.count === 0
              ? <Note tone="success">Nobody is waiting to be told.</Note>
              : (
                <>
                  <ul style={list}>{r.plan.map((p) => <li key={p.applicationId}><b>{p.candidateName || 'Unnamed'}</b> · {p.applicationId} · {p.why}; will get an email</li>)}</ul>
                  <div><Button onClick={() => run(true)}>Tell these {r.count} applicant{r.count > 1 ? 's' : ''} now</Button></div>
                </>
              )}
            {r.held?.length > 0 && (
              <Note tone="warning">
                Held; look at these yourself, nothing will be sent: {r.held.map((h) => `${h.candidateName || 'Unnamed'} (${h.why})`).join('; ')}
              </Note>
            )}
            {r.olderUntold > 0 && <div style={small}>{r.olderUntold} earlier applicant{r.olderUntold > 1 ? 's are' : ' is'} also out and never told; move the date back to include them.</div>}
          </>
        )}
        {r && r.dryRun === false && (
          <>
            <div style={{ fontWeight: 500 }}>{r.sent} of {r.count} sent.</div>
            <ul style={list}>{r.results.map((x) => <li key={x.applicationId}>{x.sent ? 'Told' : 'Not sent'}: {x.candidateName || 'Unnamed'} ({x.applicationId}){x.error ? ` · ${x.error}` : ''}</li>)}</ul>
          </>
        )}
      </div>
    </Section>
  );
}
